// extracted by mini-css-extract-plugin
export default {"title":"styles_title__r62Py","collapsed":"styles_collapsed__Y2OgW"};